import {ComponentFactory, ComponentFactoryResolver, ComponentRef, Injectable} from '@angular/core';
import { ViewContainerRef } from '@angular/core';


import { SettingsEntry } from './settings-entry';
import {AboutDialogComponent} from '../../modals/about/about-dialog.component';


@Injectable()
export class AboutEntry implements SettingsEntry {

    label: string;
    childComponent: ComponentFactory<AboutDialogComponent>;
    compRef: ComponentRef<AboutDialogComponent>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
        this.childComponent = this.componentFactoryResolver.resolveComponentFactory(AboutDialogComponent);
        this.label = 'About';
    }

    activate(viewContainerRef: ViewContainerRef): void {
        if (!this.childComponent) {
            this.childComponent = this.componentFactoryResolver.resolveComponentFactory(AboutDialogComponent);
        }
        if (!this.compRef || viewContainerRef.indexOf(this.compRef.hostView) === -1) {
            this.compRef = viewContainerRef.createComponent(this.childComponent, 0);
        }

        setTimeout(() => {
          //  this.compRef.instance.preview = true;
          //  this.compRef.instance.okText = 'Ok';
            this.compRef.instance.showDialog(true);
        }, 10);
    }

    clean() {
        this.childComponent = null;
        this.compRef = null;
    }

}


// WEBPACK FOOTER //
// ./src/app/headerfooter/setting-entries/about-entry.ts